<template>
    <div>
        <div class="contact">
            <h3>Contact</h3>
            <br>
            <dt>Twitter</dt>
            <dd>
                <a href="https://twitter.com/trippysalmon">@trippysalmon</a>
            </dd>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
export default {
    name: 'contact'
}
</script>
<style scoped>
.contact {
    padding: 24px;
}
</style>




// WEBPACK FOOTER //
// contact.vue?d95b1a36